export type StoredProductSelection = {
  selectedMaterial?: string | null;
  selectedSize?: string | null;
};

const productSelectionClientIdKey = 'product-selection-client-id';
const productSelectionKey = (productId: string) => `product-selection:${productId}`;

const createClientId = () => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const getProductSelectionClientId = () => {
  if (typeof window === 'undefined') return '';

  try {
    const existingClientId = window.localStorage.getItem(productSelectionClientIdKey);
    if (existingClientId) return existingClientId;

    const clientId = createClientId();
    window.localStorage.setItem(productSelectionClientIdKey, clientId);
    return clientId;
  } catch {
    return '';
  }
};

export const readStoredProductSelection = (productId: string): StoredProductSelection | null => {
  if (typeof window === 'undefined') return null;

  try {
    const rawValue = window.localStorage.getItem(productSelectionKey(productId));
    return rawValue ? JSON.parse(rawValue) : null;
  } catch {
    return null;
  }
};

export const writeStoredProductSelection = (
  productId: string,
  selection: StoredProductSelection
) => {
  if (typeof window === 'undefined') return;

  window.localStorage.setItem(productSelectionKey(productId), JSON.stringify(selection));
};
